import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';

@Component({
    selector: 'app-edit-tilvalg-form',
    templateUrl: './edit-tilvalg-form.component.html',
    styleUrls: ['./edit-tilvalg-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditTilvalgFormComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() tilvalgGroups: TilvalgGroupDto[];
  @Input() serviceaftale: ServiceaftaleDto;
  @Input() serviceaftaleChanged: boolean;

  get tilvalg() {
    return this.form.get('tilvalgGroups');
  }

  constructor() {}

  ngOnInit(): void {}

  isDisabled(tilvalg: TilvalgDto): boolean {
    let isDisabled: boolean = false;
    this.serviceaftale.tilvalg.forEach((existingTilvalg) => {
      if (!this.serviceaftaleChanged && existingTilvalg.tilvalgnr == tilvalg.tilvalgnr) {
        isDisabled = true;
      }
    });
    return isDisabled;
  }
}
